import DisplayMode from 'interfaces/DisplayMode'
import FormulaireV2 from './FormulaireV2/FormulaireV2'
import FormulaireV1 from './FormulaireV1/FormulaireV1'

const releaseToggleV2 = process?.env?.REACT_APP_RELEASE_TOGGLE_V2 === 'true'

interface Props {
  displayMode: DisplayMode
}

const FormulaireDeRecherche = ({ displayMode }: Props): JSX.Element | null => {
  if (displayMode.type === 'normal') {
    return releaseToggleV2 ? <FormulaireV2 /> : <FormulaireV1 />
  }
  return null
}

export default FormulaireDeRecherche
